import { List, Record } from "immutable";

import { IntegrationActorModel } from "./IntegrationActorModel";
import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";
import { PolicyModel } from "./PolicyModel";
import { TicketPermissionModel } from "./TicketPermissionModel";

export type TRevokeStatus = "manualRevokeRequested" | "notRevoking" | "pendingRevoke";
export type TSource = "external" | "ticket";
const defaults = {
  createdAt: null as Date | null,
  deprecatedAt: null as Date | null,
  givenRoleId: null as null | string,
  id: "",
  integrationActor: null as IntegrationActorModel | null,
  integrationResourceRole: null as IntegrationResourceRoleModel | null,
  policy: null as null | PolicyModel,
  revokeStatus: "notRevoking" as TRevokeStatus,
  source: "external" as TSource,
  ticketPermissions: null as List<TicketPermissionModel> | null,
};

export class IntegrationActorPermissionModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown): IntegrationActorPermissionModel {
    const {
      createdAt,
      deprecatedAt,
      givenRoleId,
      id,
      integrationActor,
      integrationResourceRole,
      policy,
      revokeStatus,
      source,
      ticketPermissions,
    } = data as typeof defaults;
    return new IntegrationActorPermissionModel({
      createdAt: createdAt ? new Date(createdAt) : null,
      deprecatedAt: deprecatedAt ? new Date(deprecatedAt) : null,
      givenRoleId: givenRoleId || null,
      id,
      integrationActor: integrationActor ? IntegrationActorModel.fromServerData(integrationActor) : null,
      integrationResourceRole: integrationResourceRole
        ? IntegrationResourceRoleModel.fromServerData(integrationResourceRole)
        : null,
      policy: policy ? PolicyModel.fromServerData(policy) : null,
      revokeStatus,
      source,
      ticketPermissions: ticketPermissions
        ? List(ticketPermissions.map((ticketPermission) => TicketPermissionModel.fromServerData(ticketPermission)))
        : null,
    });
  }
}
